<template>
	<div class="print-body">
		<div class="template-management">
			<div class="template-header">打印模板管理</div>
			<div class="template-content">
				<div class="template-left">
					<div>模板分类：</div>
				</div>
				<div class="template-right">
					<span class="default-tips" v-show="defaultflag">此模板为默认打印模板</span>
					<el-select v-model="templateValue" size="mini" placeholder="请选择" @change="templateChange">
						<el-option
							v-for="item in templateOptions"
							:key="item.printtemplateid"
							:label="item.templatename"
							:value="item.printtemplateid">
						</el-option>
					</el-select>
					<div class="template-button-box">
						<el-button plain :type=" templateValue ?  'primary' : 'info'" size="small" icon="el-icon-setting" @click="setDefault">设为默认</el-button>
						<el-button plain :type=" templateValue ?  'primary' : 'info'" size="small" icon="el-icon-search" @click="reviewTemplate">预览模板</el-button>
						<el-button plain :type=" templateValue ?  'primary' : 'info'" size="small" icon="el-icon-document" @click="copyTemplate">复制模板</el-button>
					</div>
					<div class="template-button-box">
						<el-button plain :type=" templateValue && !sysflag ?  'primary' : 'info'" size="small" icon="el-icon-edit-outline" @click="editTemplate">编辑模板</el-button>
						<el-button plain :type=" templateValue && !sysflag ?  'primary' : 'info'" size="small" icon="el-icon-delete" @click="deleteTemplate">删除模板</el-button>
						<el-button plain :type=" templateValue ?  'primary' : 'info'" size="small" icon="el-icon-download" @click="downLoadTemplate">下载模板</el-button>
					</div>
				</div>
			</div>
			<div class="tip">注：为了方便企业模版管理，在系统默认模版外，最多支持6个模版</div>
		</div>
		<div class="template-management">
			<div class="template-header">打印设置</div>
			<div class="template-content">
				<div class="template-left">
					<div>打印机选择：</div>
					<div>打印份数：</div>
				</div>
				<div class="template-right">
					<el-select v-model="printerValue" size="mini" placeholder="请选择">
						<el-option
							v-for="item in printerOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
					<div style="margin-top: 10px;width: 193px;">
						<el-input-number v-model="printerQuantity" size="mini" controls-position="right" :min="1"></el-input-number>
					</div>
				</div>
			</div>
		</div>
		<div class="printer-button">
			<el-button plain type="primary" size="small" icon="el-icon-printer" @click="printEvent">打印</el-button>
		</div>
		<el-dialog title="请确定新模板名称" append-to-body class="dialog-title" :visible.sync="editModal" width='350px' :close-on-click-modal="false">
			<el-input class='input-box' placeholder='请输入模板名称' size='mini' @change='templatenameChange' v-model="templatename" :maxlength='20'></el-input>
			<div style="margin-top: 20px;text-align: center;">
				<el-button size="mini" type="primary" plain @click="cancelClick">取 消</el-button>
				<el-button size="mini" type="primary" plain @click="saveClick">保 存</el-button>
			</div>

		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'print',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		templateType: {
			type: Number,
			default: 0
		},
		orderbyType: {
			type: Number,
			default: 0
		},
		orderSort: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			editModal: false,
			templatename: '',
			templateValue: '',
			templateOptions: [],
			printerValue: '',
			printerOptions: [],
			printerQuantity: 1,
			defaultflag: true,
			sysflag: true
		}
	},
	mounted () {
		this.deviceInit()
	},
	methods: {
		templatenameChange () {
			this.templatename = this.templatename.trim()
			this.templatename = this.templatename.replace(/[',\\]/g, '')
		},
		saveClick () {
			if (this.templatename === '') {
				this.$message.error('请输入模板名称！')
				return false
			}
			/* eslint-disable-next-line */
			let report = new FastReport()
			let params = {
				templateid: this.templateValue,
				templatetype: this.templateType,
				templatename: this.templatename
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/copyPrintTemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('复制成功!')
					this.getTemplate()
					this.getParams(report)
					this.downLoadTemplateR()
					this.editModal = false
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		cancelClick () {
			this.editModal = false
		},
		// 打印相关js文件均在public文件夹下index.html文件引入
		deviceInit () {
			let _this = this
			if (navigator.userAgent.indexOf('Windows') < 0) {
				this.$message.error('请在 Windows 系统中使用自定义打印！')
				return false
			}
			// 初始化打印
			/* eslint-disable-next-line */
			TDevices.init().then(() => {
				// 获取打印机
				_this.getPrinter()
				// 获取模板
				_this.getTemplate()
			})
		},
		getTemplate () {
			let params = {
				templatetype: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/findPrintTemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.templateOptions = res.data
					res.data.forEach(item => {
						if (item.defaultflag) {
							this.sysflag = item.sysflag
							this.templateValue = item.printtemplateid
							this.defaultflag = item.defaultflag
						}
					})
				}
			})
		},
		templateChange () {
			this.templateOptions.forEach(item => {
				if (item.printtemplateid === this.templateValue) {
					this.defaultflag = item.defaultflag
					this.sysflag = item.sysflag
				}
			})
		},
		getPrinter () {
			let _this = this
			// 实例化一个打印机相关的对象，获取打印机列表
			/* eslint-disable-next-line */
			let report = new FastReport()
			report.enable = true
			report.printerlist(function (result) {
				var printerList = result.message.list
				printerList.forEach(item => {
					_this.printerOptions.push({
						value: item,
						label: item
					})
				})
				_this.printerValue = _this.printerOptions[0].value
			})
		},
		getPrintDateBatch () {
			// 获取需要打印的单据的信息
			return new Promise((resolve, reject) => {
				let params = {
					orderids: '' + this.ids,
					templateid: this.templateValue,
					printer: this.printerValue,
					printcnt: this.printerQuantity,
					orderbyType: this.orderbyType,
					orderby: this.orderSort !== '' ? 'sortstatus' : '',
					orderSort: this.orderSort
				}
				let url = this.templateType === 0 ? `${this.$fxBaseApi.urlQIVShop}/order/print/getPrintOrderDate` : `${this.$fxBaseApi.urlQIVShop}/refundorder/print/getPrintOrderDate`
				this.$store.dispatch('requestPost', {
					url: url,
					data: params
				}).then(res => {
					if (res.result) {
						resolve(res.data)
					}
				})
			})
		},
		setDefault () {
			// 设置默认模板
			if (this.templateValue === '') {
				this.noSelectTemplate()
				return false
			}
			let params = {
				templateid: this.templateValue,
				templatetype: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/setDefaultTemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('设置成功!')
					this.defaultflag = true
					this.templateOptions.forEach(item => {
						item.defaultflag = this.templateValue === item.printtemplateid
					})
				} else {
					this.$message.error('设置失败!')
				}
			})
		},
		reviewTemplate () {
			// 预览模板
			let _this = this
			if (this.templateValue === '') {
				this.noSelectTemplate()
				return false
			}
			if (!this.printerValue) {
				this.$message.error('请选择打印机！')
				return false
			}
			if (this.ids.length > 1) {
				this.$message.error('请选择一条数据进行预览！')
				return false
			}
			this.getPrintDateBatch().then((res) => {
				/* eslint-disable-next-line */
				let report = new FastReport()
				/* eslint-disable-next-line */
				let dsDate = eval(res)
				if (dsDate.length === 1) {
					let printDate = dsDate[0]
					report.enable = true
					if (typeof printDate === 'undefined') {
						_this.$message.error('获取打印数据错误！')
					} else {
						// 预览打印数据
						report.preview(printDate)
					}
				}
			})
		},
		copyTemplate () {
			// 复制模板
			if (this.templateValue === '') {
				this.noSelectTemplate()
				return false
			}
			if (!this.printerValue) {
				this.$message.error('请选择打印机！')
				return false
			}
			this.editModal = true
			this.templatename = ''
		},
		editTemplate () {
			// 编辑模板
			let _this = this
			if (this.templateValue === '') {
				this.noSelectTemplate()
				return false
			}
			if (this.sysflag) {
				this.$message.error('系统模板不可编辑！')
				return false
			}
			this.getPrintDateBatch().then((res) => {
				/* eslint-disable-next-line */
				let report = new FastReport()
				/* eslint-disable-next-line */
				let dsDate = eval(res)
				if (dsDate.length === 1) {
					let printDate = dsDate[0]
					report.enable = true
					if (typeof (printDate) === 'undefined') {
						_this.$message.error('获取打印数据错误')
					} else {
						_this.getParams(report)
						_this.$confirm('确定修改模版？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							report.design(printDate)
						})
					}
				}
			})
		},
		getParams (report) {
			let params = {
				Host: window.location.host
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/getParams`,
				data: params
			}).then(res => {
				report.setParams(res)
			})
		},
		getParamsR (report) {
			let params = {
				Host: window.location.host
			}
			return new Promise((resolve) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/print/getParams`,
					data: params
				}).then(res => {
					report.setParams(res)
					resolve()
				})
			})
		},
		downLoadTemplate () {
			// 下载模板
			let _this = this
			// if (this.templateValue === '') {
			// 	this.noSelectTemplate()
			// 	return false
			// }
			/* eslint-disable-next-line */
			let report = new FastReport()
			/* eslint-disable-next-line */
			report.enable = true
			this.getParams(report)
			this.$confirm('确认下载模板？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				report.download(function (res) {
					if (res.retrunCode === 1) {
						_this.$message.success('下载成功!')
					} else {
						_this.$message.error('下载失败！')
					}
				})
			})
		},
		downLoadTemplateR () {
			// 下载模板
			/* eslint-disable-next-line */
			let report = new FastReport()
			/* eslint-disable-next-line */
			report.enable = true
			this.getParamsR(report).then(() => {
				setTimeout(() => {
					report.download(function (res) {
					})
				}, 1000)
			})
		},
		deleteTemplate () {
			// 删除模板
			if (this.templateValue === '') {
				this.noSelectTemplate()
				return false
			}
			if (this.sysflag) {
				this.$message.error('系统模板不可删除！')
				return false
			}
			this.$confirm('是否确认删除该模板，删除后则无法继续使用', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					templateid: this.templateValue
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/print/delPrintTemplate`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功!')
						this.getTemplate()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		noSelectTemplate () {
			this.$confirm('请选择打印模板', '提示', {
				confirmButtonText: '确定',
				type: 'warning',
				showCancelButton: false
			})
		},
		printEvent () {
			// 打印模板数据
			let _this = this
			if (this.templateValue === '' || this.printerValue === '') {
				this.$confirm('未检测到有效数据，请先添加有效数据', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					showCancelButton: false
				})
				return false
			}
			this.$confirm('是否确认打印？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.getPrintDateBatch().then((res) => {
					if (!res) {
						return false
					}
					/* eslint-disable-next-line */
					let report = new FastReport()
					/* eslint-disable-next-line */
					let dsDate = eval(res)
					report.enable = true
					if (dsDate.length > 0) {
						let printDate = dsDate
						if (typeof (printDate) === 'undefined') {
							_this.$message.error('获取打印数据错误')
						} else {
							for (let i = 0; i < printDate.length; i++) {
								// 执行打印方法
								report.print(printDate[i])
								// 更新打印次数
								_this.updateFr3PrintCs(printDate[i].DS1[0].orderid)
							}
						}
					} else {
						_this.$message.error('获取打印数据错误')
					}
				})
			})
		},
		updateFr3PrintCs (id) {
			let params = {
				orderid: id,
				templatetype: this.templateType
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/updateFr3PrintCs`,
				data: params
			})
		}

	}
}
</script>

<style lang="stylus" scoped>
.template-management {
	.tip {
		text-align: center;
		line-height: 40px;
		color: red;
	}
	padding-left: 14px;
	.template-header {
		font-size: 16px;
		padding-top: 10px;
	}
	.template-content {
		display flex;
		padding-top: 10px;
		.template-left {
			width: 85px;
			div {
				text-align right;
				margin-bottom: 20px;
			}
		}
		.template-right {
			flex: 1;
			position: relative;
			.default-tips {
				position absolute;
				color: red;
				font-size: 14px;
				left: 200px;
				top: 4px;
			}
		}
		.template-button-box {
			margin-top: 14px;
		}
	}
}
.printer-button {
	padding-top: 20px;
	display flex;
	justify-content center;
	align-items center;
}
</style>
